var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTemplateJornada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    fill: "none",
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEFF9",
    d: "M22.5 36v54h63V36h-63zm0-9h63v-9h-63v9zM90 99H18c-1.194 0-2.338-.474-3.182-1.318-.844-.844-1.318-1.989-1.318-3.182v-81c0-1.194.474-2.338 1.318-3.182C15.662 9.474 16.807 9 18 9h72c1.194 0 2.338.474 3.182 1.318.844.844 1.318 1.989 1.318 3.182v81c0 1.194-.474 2.338-1.318 3.182C92.338 98.526 91.193 99 90 99zM31.5 45h18v18h-18V45zm0 27h45v9h-45v-9zm27-22.5h18v9h-18v-9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplateJornada);
export default __webpack_public_path__ + "static/media/Icon_template-jornada.e31c53c1.svg";
export { ForwardRef as ReactComponent };